import React, { useEffect, useState } from "react";
import { Select, Spin } from "antd";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";
const { Option } = Select;

// When `options` is supplied the caller owns the list (e.g. options derived from
// the rows actually shown in a table); the component then skips its own fetch and
// no longer needs a manufacturer to be picked first, since the list is already scoped.
const VehicleSelect = ({ manufacturerId, segmentId, value, onChange, disabled = false, multiple = false, options, optionsLoading = false }) => {

  const isControlledList = Array.isArray(options);

  const { request } = useRequest();
  const [vehicleList, setVehicleList] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchVehicles = async () => {

    if (!manufacturerId) {
      setVehicleList([]);
      return;
    }

    setLoading(true);
    let url = `${apiPath.commonVehicle}?manufacturer_id=${manufacturerId}`;
    if (segmentId) url += `&segment_id=${segmentId}`;
    request({
      url,
      method: "GET",
      onSuccess: (res) => {
        const vehicles = res?.data?.data || [];
        setVehicleList(vehicles);
        setLoading(false);
      },
      onError: (err) => {
        setLoading(false);
        ShowToast(err?.response?.data?.message || "Failed to load manufacturers", Severty.ERROR);
      },
    });
  }

  useEffect(() => {
    if (isControlledList) return;
    fetchVehicles();
  }, [manufacturerId, segmentId, isControlledList]);

  const list = isControlledList ? options : vehicleList;
  const isLoading = isControlledList ? optionsLoading : loading;

  return (
    <Spin spinning={isLoading} tip="Loading vehicles..." size="small">
      <Select
        mode={multiple ? "multiple" : undefined}
        maxTagCount={multiple ? "responsive" : undefined}
        showSearch
        allowClear
        placeholder={isControlledList || manufacturerId ? "Select vehicle(s)" : "Select manufacturer first"}
        optionFilterProp="children"
        value={value}
        onChange={(val, option) => onChange?.(val, option)}
        disabled={disabled || (!isControlledList && !manufacturerId)}
        loading={isLoading}
        filterOption={(input, option) =>
          option?.children?.toLowerCase().includes(input.toLowerCase())
        }
        className="w-full"
        style={multiple ? undefined : { height: 40 }}
      >
        {list?.map((item) => (
          <Option key={item._id} value={item._id}>
            {item.en_name}
          </Option>
        ))}
      </Select>
    </Spin>
  );
};

export default VehicleSelect;
